import { Injectable, signal } from '@angular/core';
import { Device } from '@capacitor/device';

@Injectable({
  providedIn: 'root',
})
export class DeviceService {
  isIOS = signal<boolean>(false);
  isAndroid = signal<boolean>(false);
  isWeb = signal<boolean>(false);

  async init() {
    const isIOS = await this.isIOSDevice();
    const isAndroid = await this.isAndroidDevice();
    const isWeb = await this.isWebDevice();

    this.isIOS.set(isIOS);
    this.isAndroid.set(isAndroid);
    this.isWeb.set(isWeb);
  }

  async getDeviceInfo() {
    const info = await Device.getInfo();
    console.log('Device Info:', info);
    return info;
  }

  get isMobile() {
    return this.isIOS() || this.isAndroid();
  }

  async isIOSDevice() {
    const info = await Device.getInfo();
    return info.platform === 'ios';
  }

  async isAndroidDevice() {
    const info = await Device.getInfo();
    return info.platform === 'android';
  }

  async isWebDevice() {
    const info = await Device.getInfo();
    return info.platform === 'web';
  }
}
